/**
 * @file Anything that can run on every page
 */

import * as quicklink from "quicklink";
import lazyframe from "lazyframe";
import vHeader from "../components/header/header";
import vSearchBar from "../components/search-bar/search-bar";
import vFooter from "../components/footer/footer";
import vMobileNav from "../components/mobile-nav/mobile-nav";
import vHpContactForm from "../components/hp-contact-form/hp-contact-form";
import vHpHero from "../components/hp-hero/hp-hero";
import vFormNewsletter from "../components/form-newsletter/form-newsletter";
import vCreditGraph from "../components/credit-graph/credit-graph";
import vHpTimeline from "../components/hp-timeline/hp-timeline";
import vContactForm from "../components/contact-form/contact-form";
import vContent from "../components/content/content";
import vPagination from "../components/pagination/pagination";
import vFilter from "../components/filter/filter";
import vTable from "../components/table/table";
import vStsPopup from "../components/sts-pop-up/sts-pop-up";
import vSegmentHero from "../components/segment-hero/segment-hero";
import vLandingFaq from "../components/landing-faq/landing-faq";
import vFaqGrid from "../components/faq-grid/faq-grid";
import vFaqTimeline from "../components/faq-timeline/faq-timeline";
import vLandingForm from "../components/landing-form/landing-form";
import vMortgageGraph from "../components/mortgage-graph/mortgage-graph";
import vProductTour from "../components/product-tour/product-tour";
import vAccordionsList from "../components/accordions-list/accordions-list";
import vPricingCard from "../components/pricing-card/pricing-card";
import vReportsDropdown from "../components/reports-dropdown/reports-dropdown";
import vPricingTooltip from "../components/pricing-tooltip/pricing-tooltip";
import vWaitlistForm from "../components/waitlist-form/waitlist-form";
import vPricingPopup from "../components/pricing-popup/pricing-popup";
import vFeatureSlider from "../components/feature-slider/feature-slider";
import vUpgradeEligibility from "../components/upgrade-eligibility/upgrade-eligibility";
import vEnrollmentWrap from "../components/enrollment-wrap/enrollment-wrap";
import vPricingCardToggle from "../components/pricing-card-toggle/pricing-card-toggle";
import vPricingCardToggleDual from "../components/pricing-card-toggle-dual/pricing-card-toggle-dual";
import vEnrollmentResultCard from "../components/enrollment-result-card/enrollment-result-card";
import vEnrollmentResultCardIframe from "../components/enrollment-result-card/enrollment-result-card-iframe";
import vHomeCalloutStats from "../components/home-callout-stats/home-callout-stats";
import vStepAccordion from "../components/step-accordion/step-accordion";
import vCreditComparison from "../components/credit-comparison/credit-comparison";
import vLandingDynamic from "../components/landing-dynamic/landing-dynamic";
import vFiveCol from "../components/five-col-layout/five-col-layout";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

/**
 * Global functions
 *
 * Runs component js and any global tasks
 */
const vGlobal = () => {
	const dataLayer = window.dataLayer || [];
	const selects = document.querySelectorAll("select");
	// const clicks    = document.querySelectorAll( '.v-track-click' );

	/**
	 * Wraps select elements so they can be styled
	 *
	 * @param {HTMLSelectElement} select select field
	 */
	const wrapSelect = (select) => {
		const selectParent = select.parentNode;
		if (selectParent.classList.contains("v-form__select")) {
			return;
		}

		const wrapper = document.createElement("span");
		const arrow = document.createElement("span");
		wrapper.classList.add("v-form__select");
		arrow.classList.add("v-form__select-arrow");
		select.classList.add("v-form__select-input");
		selectParent.insertBefore(wrapper, select);
		wrapper.appendChild(select);
		wrapper.appendChild(arrow);
	};

	[...selects].forEach(wrapSelect);

	// const checkboxes   = document.querySelectorAll( '[type="checkbox"]' );
	// const clicks    = document.querySelectorAll( '.v-track-click' );

	/**
	 * Wraps checkbox elements so they can be styled
	 *
	 * @param {HTMLInputElement} checkbox checkbox field
	 */
	// const wrapCheckbox = ( checkbox ) => {
	// 	const checkboxParent = checkbox.parentNode;
	// 	if ( checkboxParent.classList.contains( 'v-form__checkbox' ) ) {
	// 		return;
	// 	}

	// 	const label = checkboxParent.nodeName === 'LABEL' ? checkboxParent : checkboxParent.closest( 'label' );
	// 	if ( label ) {
	// 		label.classList.add( 'v-form__checkbox-label' );
	// 	}

	// 	const wrapper = document.createElement( 'span' );
	// 	const box     = document.createElement( 'span' );
	// 	wrapper.classList.add( 'v-form__checkbox' );
	// 	box.classList.add( 'v-form__checkbox-box' );
	// 	checkbox.classList.add( 'v-form__checkbox-input' );
	// 	checkboxParent.insertBefore( wrapper, checkbox );
	// 	wrapper.appendChild( checkbox );
	// 	wrapper.appendChild( box );
	// };

	// [ ...checkboxes ].forEach( wrapCheckbox );

	const radios = document.querySelectorAll('[type="radio"]');
	[...radios].forEach((radio) => {
		const radioParent = radio.parentNode;
		const radioNext = radio.nextElementSibling;
		if (radioNext && radioNext.classList.contains("v-form__radio")) {
			return;
		}

		const customBox = document.createElement("span");
		customBox.classList.add("v-form__radio");
		radioParent.insertBefore(customBox, radio.nextSibling);
		radio.classList.add("hidden");
	});

	window.addEventListener("message", (event) => {
		if (
			event.data.type === "hsFormCallback" &&
			event.data.eventName === "onFormReady"
		) {
			const hsForm = document.querySelector(`form[id*="${event.data.id}"]`);
			const hsSelects = hsForm.querySelectorAll("select");
			[...hsSelects].forEach(wrapSelect);

			/**
			 * Wrap new selects
			 */
			const eventCb = () => {
				const newSelects = hsForm.querySelectorAll("select");
				[...newSelects].forEach(wrapSelect);
			};
			const eventConfig = {
				childList: true,
			};
			const eventObserver = new MutationObserver(eventCb);
			eventObserver.observe(hsForm, eventConfig);
		}

		if (
			event.data.type === "hsFormCallback" &&
			event.data.eventName === "onFormSubmit"
		) {
			// const hsForm = document.querySelector( `form[id*="${ event.data.id }"]` );
			if (window.dataLayer) {
				window.dataLayer.push({
					"hubspot-id": event.data.id,
					event: "hubspot-form-submit",
				});
			}
		}
	});

	document.addEventListener("facetwp-loaded", () => {
		const facetSelects = document.querySelectorAll(".facetwp-facet select");
		[...facetSelects].forEach(wrapSelect);
	});

	vHeader();
	vSearchBar();
	vMobileNav();
	vHpHero();
	vHpContactForm();
	vHpTimeline();
	vCreditGraph();
	vContactForm();
	vContent();
	vFilter();
	vPagination();
	vFormNewsletter();
	vFooter();
	vCreditComparison();
	vLandingDynamic();
	vTable();
	vStsPopup();
	vSegmentHero();
	vLandingFaq();
	vFaqGrid();
	vFaqTimeline();
	vLandingForm();
	vMortgageGraph();
	vProductTour();
	vAccordionsList();
	vPricingCard();
	vReportsDropdown();
	vPricingTooltip();
	vWaitlistForm();
	vPricingPopup();
	vFeatureSlider();
	vUpgradeEligibility();
	vEnrollmentWrap();
	vEnrollmentResultCard();
	vEnrollmentResultCardIframe();
	vPricingCardToggle();
	vPricingCardToggleDual();
	vHomeCalloutStats();
	vStepAccordion();
	vFiveCol();
	lazyframe(".lazyframe");

	/**
	 * Lazy load videos
	 */
	const lazyVideos = document.querySelectorAll(".v-lazy-video");
	const videoObserver = new IntersectionObserver((entries, o) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			const { target } = entry;
			const sources = target.querySelectorAll("source");
			[...sources].forEach((source) => {
				source.setAttribute("src", source.getAttribute("data-src"));
			});

			target.load();
			target.classList.remove("v-lazy-video");
			target.classList.add("loaded");
			o.unobserve(target);
		});
	});
	[...lazyVideos].forEach((video) => videoObserver.observe(video));
	// -------- End Lazy load videos

	// ! Start GTM Tracking
	/**
	 * Listen for links with tracking class
	 *
	 * @param e click event
	 */
	/* function trackClick( e ) {
		if ( e.target.getAttribute( 'href' ).indexOf( 'zoom.us' ) > 0 ) {
			dataLayer.push( {
				event:          'View Upcoming Webinar Schedule Button Click', // name corresponds to gtm tag
				vEventCategory: 'Zoom',
				vEventAction:   'Click',
				vEventLabel:    'Upcoming Zoom Webinars',
			} );
		}
	} */

	// * HubSpot eventNames:
	// : onFormSubmit
	// : onFormSubmitted
	// : onBeforeFormInit
	// : onFormReady
	// : onFormFailedValidation
	window.addEventListener("message", (event) => {
		// page: contact-us-on-demand/
		if (
			event.data.type === "hsFormCallback" &&
			event.data.eventName === "onFormSubmitted" &&
			event.data.id === "145f9789-9833-42b7-a414-02cc9cd80fc2" &&
			wpPostData.page_id === "1660"
		) {
			dataLayer.push({
				event: "Contact Us On Demand Form Submission", // name corresponds to gtm tag
				vEventCategory: "Hubspot",
				vEventAction: "Submit",
				vEventLabel: "View Now On-Demand",
			});
		}

		// page: get-started/
		if (
			event.data.type === "hsFormCallback" &&
			event.data.eventName === "onFormSubmitted" &&
			event.data.id === "145f9789-9833-42b7-a414-02cc9cd80fc2" &&
			wpPostData.page_id === "1664"
		) {
			dataLayer.push({
				event: "Get Started Contact Us Page - Form Submit Button Click", // name corresponds to gtm tag
				vEventCategory: "Hubspot",
				vEventAction: "Submit",
				vEventLabel: "Connect with a Product Specialist",
			});
		}
	});
	// ! End GTM Tracking

	/**
	 * Global Window Load
	 *
	 * Runs polyfills on page load
	 */
	function onWindowLoad() {
		const body = document.querySelector("body");
		if (!body.classList.contains("admin-bar")) {
			quicklink.listen({
				ignores: [
					(url) => {
						const cleanUrl = url.replace(/#.*/, "");
						return cleanUrl === window.location.href;
					},
					/.*\/wp-admin\/.*/,
				],
			});
		}
	}

	/**
	 * Global Smooth Scroll
	 *
	 * Runs smooth scroll on page load
	 */

	gsap.registerPlugin(ScrollToPlugin);

	/**
	 * Initializes smooth scrolling functionality for anchor links
	 */
	const initSmoothScroll = () => {
		const smoothScroll = (e) => {
			e.preventDefault();
			const target = e.currentTarget;
			const { hash } = target;
			const element = document.querySelector(hash);

			if (!element) {
				return;
			}

			const { top } = element.getBoundingClientRect();
			const windowY = window.scrollY;

			gsap.to(window, {
				duration: 1,
				ease: "power2.inOut",
				scrollTo: {
					y: parseInt(top + windowY, 10),
				},
			});
		};

		// Add to any anchor links
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener("click", smoothScroll);
		});
	};

	initSmoothScroll();

	// track clicks on elements with `.v-track-click`.
	// [ ...clicks ].forEach( ( click ) => {
	// 	click.addEventListener( 'click', trackClick );
	// } );

	if (document.readyState === "complete") {
		onWindowLoad();
	} else {
		window.addEventListener("load", onWindowLoad);
	}
};

if (document.readyState !== "loading") {
	vGlobal();
} else {
	document.addEventListener("DOMContentLoaded", vGlobal);
}
